// extracted by mini-css-extract-plugin
export default {"card":"TeaserCard_card_UglMW"};